import React, { useRef, useState } from 'react'
import { CalenderIcon, CalculatorIcon, Arrow, AddSmallIcon, DeleteIcon, AddIcon } from '../../Images/svgs';
import DropDown from '../Partials/DropDown';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDropdown, setSelectedValue } from '../../Managment/Slice';

function AnamZaka() {
    const [feed, setFeed] = useState([{ name: '', value: '' }]);
    const inputRefs = useRef([]);
    const handleChange = (index, name, value) => {
        const newFeed = [...feed];
        newFeed[index] = { name, value };
        setFeed(newFeed);
    };
    const HandleRemoveMoreInputs = () => {
        if (feed.length > 1) {
            const newFeed = [...feed];
            newFeed.pop();
            setFeed(newFeed);
        }
    }

    const HandleAddMoreInputs = () => {
        const newFeed = [...feed];
        newFeed.push(feed.length + 1);
        setFeed(newFeed);
    }

    const dispatch = useDispatch();
    const showlists = useSelector(state => state.dropdown.showlists);
    const selectedValues = useSelector(state => state.dropdown.selectedValues);

    const toggleDropDown = (index) => {
        dispatch(toggleDropdown({ index }));
    };

    const handleSelect = (value, index) => {
        dispatch(setSelectedValue({ index, value }));
    };

    const anams = [
        { text: 'إبل' },
        { text: 'ماعز' },
        { text: 'غنم' },
        { text: 'بقر' },
    ];


    const year = [
        { text: 'ميلادي' },
        { text: 'هجري' }

    ];

    const currencies = [
        { text: 'دولار' },
        { text: 'ليرة' },
        { text: 'دينار' },
    ];

    return (
        <>
            <div className="justify-end">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                    <div className="flex flex-col ml-5 w-[67%] max-md:ml-0 max-md:w-full">
                        <div className="flex flex-col grow px-5 py-10 w-full text-sm bg-white rounded-lg border border-solid border-black border-opacity-20 max-md:mt-5 max-md:max-w-full">
                            <div className="self-start text-base font-medium whitespace-nowrap text-slate-700">
                                اختر السنة
                            </div>
                            <div className="relative flex gap-2 justify-between px-3.5 py-2.5 mt-1.5 font-medium leading-6 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-zinc-600 max-md:flex-wrap max-md:max-w-full">
                                <input className='outline-none grow max-md:max-w-full'
                                    onClick={() => toggleDropDown(6)}
                                    value={selectedValues[0]}
                                    readOnly
                                    placeholder="هجري" />
                                <Arrow className="my-auto w-5 aspect-square" />
                                <DropDown links={year} isOpen={showlists[6]} onSelect={(value) => handleSelect(value, 0)} dropdownId={6} />
                            </div>
                            <div className="flex gap-2 justify-between px-3.5 py-2.5 mt-5 leading-6 text-right rounded-lg border border-gray-300 border-solid shadow-sm bg-stone-50 max-md:flex-wrap max-md:max-w-full">
                                <div className="grow text-gray-500 max-md:max-w-full">
                                    نسبة الزكاة حسب السنة التي قمت بإختيارها
                                </div>
                                <div className="font-bold text-blue-900">{selectedValues[0] === 'ميلادي' ? '0.0275%' : '2.5%'}</div>
                            </div>
                            <div className="self-start mt-5 text-base font-medium whitespace-nowrap text-slate-700">
                                أنواع الأنعام
                            </div>
                            <div className='flex flex-col gap-2'>
                                <div className="flex gap-1.5 justify-end mt-1.5 font-medium leading-6 text-right whitespace-nowrap text-zinc-600 max-md:flex-wrap max-md:max-w-full">
                                    <div className='flex flex-col gap-2 w-full'>
                                        {feed.map((filteredItem, index) => (
                                            <div key={index} className='relative flex flex-row w-full gap-1.5 justify-end font-medium leading-6 text-right whitespace-nowrap text-zinc-600 max-md:flex-wrap max-md:max-w-full'>
                                                <div className='grow flex flex-row justify-center outline-none text-black px-3.5 py-2.5 bg-white rounded-lg border border-gray-300 border-solid shadow-sm'>
                                                    <input
                                                        ref={(element) => (inputRefs.current[index] = element)}
                                                        className='outline-none grow'
                                                        onClick={() => toggleDropDown(1)}
                                                        placeholder="اختر نوع الأنعام"
                                                        value={selectedValues[2]}
                                                        onChange={(e) => handleChange(index, e.target.value, filteredItem.value)}
                                                        readOnly
                                                    />
                                                    <Arrow className="my-auto w-5 aspect-square" />
                                                    <DropDown links={anams} isOpen={showlists[1]} onSelect={(value) => handleSelect(value, 2)} dropdownId={1} />
                                                </div>
                                                <input
                                                    ref={(element) => (inputRefs.current[index + feed.length] = element)}
                                                    className="grow justify-center outline-none text-black px-3.5 py-2.5 bg-white rounded-lg border border-gray-300 border-solid shadow-sm"
                                                    placeholder="العدد"
                                                    value={filteredItem.value}
                                                    onChange={(e) => handleChange(index, filteredItem.name, e.target.value)}
                                                />
                                                <button onClick={HandleRemoveMoreInputs} className='flex self-center'>
                                                    <DeleteIcon />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <button onClick={HandleAddMoreInputs} className='flex items-center justify-center'>
                                    <AddIcon className="w-auto h-6 sm:h-8 aspect-square" />
                                </button>
                            </div>
                            <div className="self-start mt-5 text-base font-medium whitespace-nowrap text-slate-700">
                                أنعام التجارة
                            </div>
                            <div className="flex gap-2 justify-end px-3.5 py-2.5 mt-1.5 font-medium leading-6 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-zinc-600 max-md:flex-wrap max-md:max-w-full">
                                <input className="text-black outline-none grow max-md:max-w-full"
                                    placeholder='صافي الربح من التجارة'
                                />
                                <button className='relative flex flex-row gap-2'
                                    onClick={() => toggleDropDown(8)}
                                >
                                    <div>|</div>
                                    <div>{selectedValues[1] || 'دولار'}</div>
                                    <Arrow />
                                    <DropDown links={currencies} isOpen={showlists[8]} onSelect={(value) => handleSelect(value, 1)} dropdownId={8} />
                                </button>

                            </div>
                            <div className="self-start mt-5 text-base font-medium whitespace-nowrap text-slate-700">
                                أنعام الحليب
                            </div>
                            <div className="flex gap-2 justify-end px-3.5 py-2.5 mt-1.5 font-medium leading-6 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-zinc-600 max-md:flex-wrap max-md:max-w-full">
                                <input className="grow max-md:max-w-full text-black outline-none"
                                    placeholder='صافي الربح من الحليب'
                                />
                                <button className='relative flex flex-row gap-2'
                                    onClick={() => toggleDropDown(9)}
                                >
                                    <div>|</div>
                                    <div>{selectedValues[1] || 'دولار'}</div>
                                    <Arrow />
                                    <DropDown links={currencies} isOpen={showlists[9]} onSelect={(value) => handleSelect(value, 1)} dropdownId={9} />
                                </button>
                            </div>
                            <div className="self-start mt-5 text-base font-medium whitespace-nowrap text-slate-700">
                                أنعام عاملات
                            </div>
                            <div className="flex gap-2 justify-end px-3.5 py-2.5 mt-1.5 font-medium leading-6 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-zinc-600 max-md:flex-wrap max-md:max-w-full">
                                <input className="grow max-md:max-w-full text-black outline-none"
                                    placeholder='صافي الربح من العمل'
                                />
                                <button className='relative flex flex-row gap-2'
                                    onClick={() => toggleDropDown(0)}
                                >
                                    <div>|</div>
                                    <div>{selectedValues[1] || 'دولار'}</div>
                                    <Arrow />
                                    <DropDown links={currencies} isOpen={showlists[0]} onSelect={(value) => handleSelect(value, 1)} dropdownId={0} />
                                </button>
                            </div>
                            <button className="justify-center self-start px-3.5 py-2 mt-10 font-medium whitespace-nowrap bg-amber-300 rounded-lg shadow-sm leading-[143%] text-neutral-900">
                                احسب قيمة الزكاة
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
                        <div className="flex flex-col px-5 py-10 mx-auto w-full rounded-2xl border border-solid bg-emerald-300 bg-opacity-20 border-[color:var(--Main-Colors-4,#54E8B2)] max-md:mt-5">
                            <CalculatorIcon
                                className="self-start aspect-square w-[54px]"
                            />
                            <div className="mt-3 text-sm font-bold leading-6 text-right whitespace-nowrap text-neutral-900">
                                قيمة الزكاة المراد اخراجها هي
                            </div>
                            <div className="mt-3 text-2xl font-bold leading-5 text-right text-black whitespace-nowrap">
                                565 دينار
                            </div>
                            <div className="flex gap-3 pl-20 mt-10 max-md:pl-5">
                                <button className="justify-center px-3.5 py-2 text-sm font-medium leading-5 whitespace-nowrap bg-amber-300 rounded-lg shadow-sm text-neutral-900">
                                    اخرج زكاتك الان
                                </button>
                                <button className="flex justify-center items-center px-3.5 py-2 bg-blue-600 rounded-lg shadow-sm aspect-[1.33]">
                                    <CalenderIcon
                                        className="w-5 aspect-square"
                                    />
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AnamZaka